/* eslint-disable */
import mycolor from '@/mycolor.js';
import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router'
import axios from 'axios';
import store from './store.js';
/* eslint-disable */

Vue.config.productionTip = false

// グローバル変数
// 予約チップの色 ホワイト, イエロー, ブルー, グレー, グレー, レッド
Vue.prototype.$colors = ['#FFFFFF', '#F8F1B2', '#DBE6F6', '#E2E1E1', '#E2E1E1', '#FFD2D0'];
Vue.prototype.$interval_time = 30000;

if( location.hostname==='localhost' || location.hostname==='192.168.68.51' || location.hostname==='133.130.90.136' ) {
    // 開発環境
    Vue.prototype.$fastapi = 'http://' + location.hostname + ':9000/api';
    Vue.prototype.$websocket = 'ws://' + location.hostname + ':9000/api/chat';
    Vue.prototype.$static_url = 'http://' + location.hostname + ':8000/'
    Vue.prototype.$is_dev = true;
    console.log('main.js: is_dev: true');
}
else{
    // 本番環境
    Vue.prototype.$fastapi = 'https://'+location.hostname+'/api';
    Vue.prototype.$websocket = 'wss://'+location.hostname+'/api/chat';
    Vue.prototype.$static_url = 'https://' + location.hostname + ':8000/'
    Vue.prototype.$is_dev = false;
}



// グローバルメソッド
Vue.mixin({
  methods: {
      // ここで定義したmethodはcomponentのどこからでも呼べる.
      myglobalFunc(){
          console.log('myglobalFunc()');
      }
  },  // methods
});




console.group();
console.log('%c main.js', mycolor.pink);
console.log('location: ', location);
console.log('is_dev: ', Vue.prototype.$is_dev);
console.log('========== initialize ==========');
console.log('fastapi: ', Vue.prototype.$fastapi);
console.groupEnd();



// axiosの共通設定
axios.defaults.baseURL = Vue.prototype.$fastapi;

// 毎回トークンを送ってもらうようにする.
let access_token = '';
let user = null;
try{
    user = JSON.parse(localStorage.getItem('user'));
}catch(e){
    console.log(e);
}


if(user!==null){
    access_token = user.access_token;
}
axios.defaults.headers.common['Authorization'] = 'Bearer ' + access_token;
// 必要だったら下記付与してみてください.
//axios.defaults.headers.post['Access-Control-Allow-Origin'] = '*';
//axios.defaults.headers.get['Access-Control-Allow-Origin'] = '*';
//axios.defaults.headers.post['Content-Type'] = 'application/json;charset=utf-8';
//axios.defaults.headers.get['Content-Type'] = 'application/json;charset=utf-8';


new Vue({
  store,
  vuetify,
  router,
  render: h => h(App)
}).$mount('#app')

